import { render, staticRenderFns } from "./AnnexSection.vue?vue&type=template&id=e4c2bddc&"
import script from "./AnnexSection.js?vue&type=script&lang=js&"
export * from "./AnnexSection.js?vue&type=script&lang=js&"
import style0 from "./AnnexSection.vue?vue&type=style&index=0&id=e4c2bddc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports